
  import { css } from 'lit';
  export const styles = css`:host{--ig-theme: bootstrap;--ig-theme-variant: light}`;
  